import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import ModalComponent from '../../../components/modal/ModalComponent';

interface Props {
  open: boolean;
  close: () => void;
  loading: boolean;
  confirmArchive: () => void;
  formName: string | undefined;
}

const ArchiveFormModal: FC<Props> = ({ open, close, confirmArchive, formName, loading }: Props) => {
  const intl = useIntl();

  return (
    <ModalComponent
      closeSettings={close}
      buttons={[
        {
          text: intl.formatMessage({ id: 'cancel' }),
          buttonVariant: 'secondary',
          onClick: close,
        },
        {
          text: intl.formatMessage({ id: 'formList.buttons.archive' }),
          loading: loading,
          buttonVariant: 'danger',
          onClick: confirmArchive,
        },
      ]}
      show={open}
      modalHeading={intl.formatMessage({
        id: 'formList.archiveModal.archiveModalHeader',
      })}
      modalSize="lg"
    >
      <div className="d-flex justify-content-center flex-column">
        <label className="modal-label">
          <b>
            {intl.formatMessage({ id: 'formList.archiveModal.archiveConfirmation' })}
            &nbsp;&lsquo;{formName}&lsquo;
          </b>
        </label>
      </div>
    </ModalComponent>
  );
};

export default ArchiveFormModal;
